import { render } from "./HeaderMaiora.vue?vue&type=template&id=55273026&scoped=true"
import script from "./HeaderMaiora.vue?vue&type=script&lang=js"
export * from "./HeaderMaiora.vue?vue&type=script&lang=js"

import "./HeaderMaiora.vue?vue&type=style&index=0&id=55273026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55273026"]])

export default __exports__